module.exports = __webpack_public_path__ + "img/hubspot.58f4128c.png";